import { apply, type RulesLogic } from "json-logic-js"

const allowedOperators = new Set([
  "var",
  "missing",
  "missing_some",
  "if",
  "==",
  "===",
  "!=",
  "!==",
  "!",
  "!!",
  "or",
  "and",
  ">",
  ">=",
  "<",
  "<=",
  "in",
])

export function pluginConditionAllowed(input: unknown): boolean {
  if (input === null || typeof input !== "object") return true
  if (Array.isArray(input)) return input.every(pluginConditionAllowed)
  const entries = Object.entries(input)
  if (entries.length !== 1) return false
  return allowedOperators.has(entries[0]![0]) && pluginConditionAllowed(entries[0]![1])
}

export function evaluatePluginCondition(input: unknown, context: Record<string, unknown>) {
  if (!pluginConditionAllowed(input)) return false
  return Boolean(apply(input as RulesLogic, context))
}
